import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import * as yup from 'yup-legacy';
import { Form } from '../../../../components/form/Form';
import { Input } from '../../../../components/form/Input';
import SubmitButton from '../../../../components/form/SubmitButton';
import { useMutationErrorHandler } from '../../../../hooks/useMutationErrorHandler';
import {
  Flair__Employee__C,
  useRegisterMutation,
} from '../../__generated__/graphql';
import { useJwtAuth } from '../Login/useJwtLogin';

type Props = {
  employee: Flair__Employee__C;
  organizationId: string;
  token: string;
};

type FormData = {
  password: string;
};

const formSchema = yup.object().shape<FormData>({
  password: yup.string().required().min(8),
});

const RegistrationForm: React.FC<React.PropsWithChildren<Props>> = ({
  token,
  organizationId,
  employee,
}) => {
  const [serverErrors, setServerErrors] = useState<boolean>(false);
  const { doLoginByAuthorizationCode, loginErrors } = useJwtAuth();
  const { t } = useTranslation();
  const [doRegister] = useRegisterMutation();
  const errorHandler = useMutationErrorHandler();

  const onSubmit = async ({ password }: FormData) => {
    setServerErrors(false);
    try {
      const { data } = await doRegister({
        variables: { token, organizationId, password },
      });

      const authorizationCode = data?.register?.authorizationCode;
      if (!authorizationCode) {
        setServerErrors(true);
        return;
      }

      await doLoginByAuthorizationCode(authorizationCode);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <h1 className="display-4 text-center mb-3">
        {t('registration.title', { name: employee.flair__First_Name__c })}
      </h1>
      <p className="text-muted text-center mb-5">
        {t('registration.subTitle')}
      </p>
      <Form
        onSubmit={onSubmit}
        validationSchema={formSchema}
        defaultValues={{ password: '' }}>
        <Input
          label={t('form.general.passwordNew.label')}
          placeholder={t('form.general.passwordNew.placeholder')}
          name="password"
          type="password"
        />

        {serverErrors || loginErrors ? (
          <p className="text-danger">{t('signIn.invalid')}</p>
        ) : (
          <></>
        )}

        <SubmitButton block>{t('registration.button')}</SubmitButton>
      </Form>
    </>
  );
};

export default RegistrationForm;
